import { ArrowRight } from 'lucide-react';
import { Card, Steps, PhoneFold } from '@dru/ui';
import { caseJourney, type JourneyInput } from '../lib/caseJourney';

/**
 * Where a medical case is, what happens next, and who has to act.
 *
 * Drawn from operational facts only — status, lab, appointment — so it is
 * safe on a screen that must show nothing clinical.
 */
export function CaseJourney(props: JourneyInput & { className?: string }) {
  const j = caseJourney(props);
  return (
    <Card className={props.className}>
      {/* One line: what happens next and who does it. Where the case is now
          is the highlighted step below, and the badge in the header. */}
      {(j.next || j.halted) && (
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 border-b border-neutral-200 px-5 py-3 text-small">
          {j.next && (
            <>
              <ArrowRight aria-hidden className="h-4 w-4 shrink-0 text-primary-600" />
              <span className="text-neutral-500">Next:</span>
              <span className="font-medium text-neutral-900">{j.next}</span>
              {j.actor && <span className="text-neutral-500">· by {j.actor.toLowerCase()}</span>}
            </>
          )}
          {j.halted && <span className="text-neutral-600">{j.halted}</span>}
        </div>
      )}
      <div className="px-5 py-4">
        {/* Seven steps stacked are 300px on a phone, above the thing the
            reader came to do. "Now" and "Next" above already say where it is. */}
        <PhoneFold label="case progress">
          <Steps steps={j.steps} label="Case progress" />
        </PhoneFold>
      </div>
    </Card>
  );
}
